import { useAvContext } from "@minervaproject/avsubsystem";
import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { Settings } from "settings";
import { MonitoringEventTypeType } from "shared/types/monitoring_event";
import { createMonitoringEvent } from "store/reducers/monitoring";
import { selectCurrentUserIsAvEnabled } from "store/selectors/classroom";
import { selectCurrentUserId } from "store/selectors/local";

function AvCheckInTask() {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(selectCurrentUserId());
  const isAvEnabled = useAppSelector(selectCurrentUserIsAvEnabled());
  const avConnection = useAvContext();
  useEffect(() => {
    if (isAvEnabled) {
      const interval = setInterval(() => {
        // We use the normal Av digest from the monitoring event but add more details for the published connection
        const publisherStats = avConnection?.getPublisherConnectionDetails() || null;
        dispatch(
          createMonitoringEvent({
            type: MonitoringEventTypeType.AV_CHECKIN,
            userId: currentUserId,
            contextData: { publisherStats },
          }),
        );
      }, Settings.AV_CHECKIN_INTERVAL);
      return () => clearInterval(interval);
    }
  }, [dispatch, currentUserId, isAvEnabled, avConnection]);

  return null;
}

export { AvCheckInTask };
